import React from 'react';
import '../Game.css';

interface GotchaProps {
  roomId: string;
  roomData: any;
}

function Gotcha({ roomId, roomData }: GotchaProps) {
  console.log('room data: ', roomData)
  return (
    <div className="game-container">
      <div className="game-header">
        <h2>🎯 Gotcha Game</h2>
        <div className="room-id-display">{roomId}</div>
        
        <div className="game-info">
          <div className="info-item">
            <div className="info-label">Room ID</div>
            <div className="info-value">{roomData?.roomId}</div>
          </div>
          <div className="info-item">
            <div className="info-label">Room Name</div>
            <div className="info-value">{roomData?.roomName}</div>
          </div>
          <div className="info-item">
            <div className="info-label">Admin</div>
            <div className="info-value">{roomData?.adminAlias}</div>
          </div>
          <div className="info-item">
            <div className="info-label">Players</div>
            <div className="info-value">{roomData?.currentParticipantCount}/{roomData?.maxParticipants}</div>
          </div>
          <div className="info-item">
            <div className="info-label">Game State</div>
            <div className="info-value">{roomData?.gameState}</div>
          </div>
        </div>
      </div>
      
      <div className="game-content">
        {roomData?.gameState === 'ongoing' ? (
          <div className="coming-soon">
            <p>🚧 Game content coming soon...</p>
          </div>
        ) : (
          <div className="coming-soon">
            <p>⏳ Waiting for admin to start the game...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Gotcha;
